var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"_copy_3"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"final","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Play","transform":"translate(-490.000000, -763.000000)","fill":"#0E0E0E"},React.createElement("g",{"id":"Group-2","transform":"translate(470.000000, 284.000000)"},React.createElement("g",{"id":"Group","transform":"translate(20.000000, 479.000000)"},React.createElement("path",{"d":"M7,0 L10,0 L10,14 L7,14 L7,0 Z M0,0 L3,0 L3,14 L0,14 L0,0 Z","id":"_copy_3"})))))]);
}

Pause.defaultProps = {"width":"10px","height":"14px","viewBox":"0 0 10 14","version":"1.1"};

module.exports = Pause;

Pause.default = Pause;
